export default __webpack_public_path__ + "static/media/secondary-planets.40f8c073.png";